import { IconActionMore16 } from '@cian/ui-kit-design-tokens/icons';
import { Modal } from '@cian/ui-kit/modal';

import * as React from 'react';

import { EditActionContainer } from '../EditActionContainer';
import { DeleteActionContainer } from '../DeleteActionContainer';
import { MenuList } from '../../../components/SavedSearches/MobileComponents/MenuList';
import { ActionsMenuHeader } from '../../../components/SavedSearches/MobileComponents/ActionsMenuHeader';
import { trackActionsMenuClick } from './trackings';

export interface IActionsMenuContainerProps {
  isOpen: boolean;
  name?: string;
  description?: string | null;
  onOpenChange(value: boolean): void;
  onOpenDeleteModal(): void;
  onOpenEditModal(): void;
}

export const ActionsMenuContainer: React.FC<IActionsMenuContainerProps> = ({
  isOpen,
  name,
  description,
  onOpenChange,
  onOpenDeleteModal,
  onOpenEditModal,
}) => {
  const handleClick = React.useCallback(() => {
    onOpenChange(true);
    trackActionsMenuClick();
  }, []);

  return (
    <>
      <IconActionMore16 color="icon-main-default" onClick={handleClick} />
      <Modal
        header={<ActionsMenuHeader name={name} description={description} />}
        open={isOpen}
        onOpenChange={() => onOpenChange(false)}
        body={
          <MenuList>
            <EditActionContainer onClick={onOpenEditModal} />
            <DeleteActionContainer onClick={onOpenDeleteModal} />
          </MenuList>
        }
      />
    </>
  );
};
